module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }), _c('div', {
    staticClass: "title-frontMatter"
  }, [_c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Dear Reader,")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("To me, Harlequin Presents"), _c('sup', [_vm._v("®")]), _vm._v(" has always been at the cutting edge of contemporary romance and I’ve loved the uninhibited scope and pleasure of writing about today’s relationships with their complex problems and passions.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Best of all, in these stories, the dream of love we nurse in our hearts can always be fulfilled. It’s a special world we share—the magic of romance—and I hope you love it and enjoy it as much as I do, sharing the lives of others whose dearest wishes do come true.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Happy twenty-fifth birthday to Harlequin Presents!")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Emma Darcy")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c47001","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781459262102_fm02.vue
// module id = 63
// module chunks = 0